export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive("resize", {
        mounted(el, binding) {
            const callback = binding.value;
            const resizeObserver = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    callback(entry);
                }
            });

            resizeObserver.observe(el);
            el._resizeObserver = resizeObserver;
        },
        unmounted(el) {
            if (el._resizeObserver) {
                el._resizeObserver.disconnect();
                delete el._resizeObserver;
            }
        },
    });
});
